import rootReducer from "./modules";
import { loadState } from "./localStorage";
import { createBrowserHistory } from "history";
import { configureStore } from "@reduxjs/toolkit";
import { locationChanged } from "./modules/router/routerSlice";
import { rejectionNotificationMiddleware } from "./rejectionNotificationMiddleware";

export const history = createBrowserHistory();

const persistedState = loadState();

const store = configureStore({
  reducer: rootReducer,
  preloadedState: persistedState,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(rejectionNotificationMiddleware),
});

// Initial sync of history to redux
store.dispatch(
  locationChanged({ location: history.location, navAction: history.action }),
);

// Listen to history changes and update redux router slice
history.listen((location, navAction) => {
  store.dispatch(locationChanged({ location, navAction }));
});

export default store;
